import ReactTable, { ReactTableDefaults } from "react-table";
import React, { Component } from "react";

import "react-table/react-table.css";

import "./reactTable.css";

import Pagination from "./Pagination";
import propTypes from "prop-types";

export default class ReactTableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: {} };
  }

  paginate = (pageNumber, size) => {
    this.props.updatePagination(pageNumber, size);
  };

  noDataComponent = () => {
    return (
      <h5 style={{ textAlign: "center", fontSize: "14px", marginTop: "20px" }}>
        No records found.
      </h5>
    );
  };

  render() {
    if (this.props.listConfig.showSerialNo === true) {
      this.props.listData.map((item, index) => {
        return (item.sNo =
          this.props.forSerialNo !== undefined
            ? this.props.forSerialNo.pageNo -
              this.props.forSerialNo.pageSize +
              index +
              1
            : index + 1);
      });
    }
    let subArrayLength=0
    this.props.listData.map(items=>{
      if(items.subArray)
      subArrayLength +=items.subArray.length
    })
    let totalLength= this.props.expansion?this.props.listData.length+subArrayLength:this.props.listData.length
    let dataRange = {
      first:
        this.props.forSerialNo.pageNo - this.props.forSerialNo.pageSize + 1,
      last:
        this.props.forSerialNo.pageNo -
        this.props.forSerialNo.pageSize +
        totalLength,
    };

    return (
      <div>
        <div>
          <ReactTable
            className="-striped"
            manual
            getTrProps={(state, rowInfo) => ({
              onClick: () => {
                return this.props.onRowClick
                  ? this.props.onRowClick(rowInfo)
                  : "";
              },
            })}
            getTheadThProps={(state, rowInfo, column, instance) => ({
              ...ReactTableDefaults.getTheadThProps,

              onClick: () => {
                return this.props.onHeaderClick
                  ? this.props.onHeaderClick(column.id)
                  : "";
              },
            })}
            expanded={this.state.expanded}
            onExpandedChange={(expandedList) => {
              const expanded = {};
              Object.keys(expandedList).forEach((item) => {
                const expand = Boolean(
                  expandedList[item] &&
                    expandedList[item].constructor === Object
                );
                expanded[item] = expand;
              });
              this.setState({ expanded });
            }}
            TheadComponent={this.props.TheadComponent}
            minRows={0}
            pageSize={1}
            data={this.props.listData}
            columns={this.props.columns}
            pages={0}
            showPagination={false}
            SubComponent={this.props.subComponent}
            NoDataComponent={this.noDataComponent}
          />

          {this.props.listConfig.showPagination &&
          this.props.listData.length !== 0 ? (
            <Pagination
              dataPerPage={10}
              totalData={this.props.dataCount ? this.props.dataCount : ""}
              paginate={this.paginate}
              initialPage={this.props.initialPage}
              dataRange={dataRange}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

ReactTableComponent.protoType = {
  listData: propTypes.array.isRequired,
  columns: propTypes.array.isRequired,
  paginate: propTypes.func,
  onRowClick: propTypes.func,
};
